import React, { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  ButtonGroup,
  Dropdown,
  Modal,
  Form,
  Table,
  Nav,
  Tab,
  Tabs,
  Card,
  Breadcrumb,
  FormCheck
} from "react-bootstrap";

import { auth } from "../config/Config";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

export default function AddQuotation() {

  const userDetailsLocal = localStorage.getItem('userDetails');
  const userDetailsLo = JSON.parse(userDetailsLocal);

  const navigation = useNavigate();
  const location = useLocation();
  const data = location.state;
  const dispatch = useDispatch();

  const [value, setValue] = useState([]);
  const [sta, setSta] = useState(false);
  const [inputTitle, setInputTitle] = useState('');
  const [inputBase, setInputBase] = useState(0);
  const [inputDiscount, setInputDiscount] = useState(0);
  const [InputTaxation, setInputTaxation] = useState(0);
  const [inputSpecialDiscount, setInputSpecialDiscount] = useState(0);
  const [loading, setLoading] = useState(false);

  // ─── Phase thresholds ────────────────────────────────────────────────────
  // Phase 1 : before  Apr 7 2026  → GST free, discount unlimited
  // Phase 2 : Apr 7 – May 26 2026 → GST 18% fixed
  //           BLR: discount unlimited up to 25%  |  KKT: discount unlimited
  // Phase 3 : May 27 2026 onwards → GST 18% fixed
  //           BLR: discount max 5%, Special Discount field shown
  //           KKT: discount unlimited, Special Discount field hidden
  // ─────────────────────────────────────────────────────────────────────────
  const savedTime = localStorage.getItem('projectCreationTime');
  const projectDate = savedTime ? new Date(savedTime) : null;

  const allowedDiscount = localStorage.getItem('maxDiscountApproved');

  const april7  = new Date('2026-04-07T00:00:00');
  const may27   = new Date('2026-05-27T00:00:00');

  // Determine which phase the project falls into
  const isPhase3 = projectDate ? projectDate >= may27   : false; // on/after May 27
  const isPhase2 = projectDate ? (projectDate >= april7 && projectDate < may27) : false; // Apr 7 – May 26
  // isPhase1 = everything else (before Apr 7)

  // ─── Location ────────────────────────────────────────────────────────────
  const userLocation = userDetailsLo?.location?.toLowerCase?.() || '';
  const isKKT = userLocation === 'kkt';
  const isBLR = userLocation === 'blr';

  // ─── GST rule ─────────────────────────────────────────────────────────────
  // Phase 2 & 3 (both locations): GST locked at 18%
  // Phase 1: user can freely enter GST
  const isGSTFixed = isPhase2 || isPhase3;
  const effectiveTaxation = isGSTFixed ? 18 : InputTaxation;

  // ─── Discount cap rule ───────────────────────────────────────────────────
  // BLR Phase 2: max 25%
  // BLR Phase 3: max 5%
  // KKT all phases / BLR Phase 1: no cap
  let maxDiscount;
  if (isBLR && isPhase2) maxDiscount = allowedDiscount ? allowedDiscount : 25;
  else if (isBLR && isPhase3) maxDiscount = allowedDiscount ? allowedDiscount : 5; // enforce BLR Phase 3 cap, but also respect any stricter cap set by management
  else maxDiscount = undefined; // no cap

  // ─── Special Discount visibility ─────────────────────────────────────────
  // Shown only in Phase 3 AND not KKT
  const showSpecialDiscount = isPhase3 && !isKKT;
  // ─────────────────────────────────────────────────────────────────────────

  const { allAssigneRoomData } = useSelector((state) => state.assigneProjectRooms);
  const { viewData } = useSelector((state) => state.viewrooms);

  useEffect(() => {
    if (data.path === 'assigneRooms') {
      setViewDatas(allAssigneRoomData.assignedRooms);
    } else {
      setViewDatas(viewData);
    }
  })

  const [viewDatas, setViewDatas] = useState([]);

  const result = viewDatas?.reduce((finalArray, current) => {
    let obj = finalArray.find((item) => item.roomTypeName === current.roomTypeName);
    if (obj) {
      return finalArray;
    }
    return finalArray.concat([current]);
  }, []);

  const handleLogOut = () => {
    auth.signOut();
  }

  const [userinfo, setUserInfo] = useState([{
    languages: [],
    response: [],
  }]);
  const [peopleInfo, setPeopleInfo] = useState([]);

  const [calculationWood, setCalculationWood] = useState(0);
  const [calculationAccess, setCalculationAccess] = useState(0);
  const [calculationInfo, setCalculationInfo] = useState(0);
  const [selectedDesigns, setSelectedDesigns] = useState({});
  const [finalPrice, setFinalPrice] = useState(0);

  useEffect(() => {
    if (inputDiscount || effectiveTaxation || inputSpecialDiscount) {
      const afterDiscount = Math.round(calculationInfo - calculationWood * (inputDiscount / 100));
      const afterSpecialDiscount = Math.round(afterDiscount - inputSpecialDiscount);
      const totalTaxation = Math.round(afterSpecialDiscount * (effectiveTaxation / 100));
      const finalPrice = Math.round(afterSpecialDiscount + totalTaxation);
      setFinalPrice(finalPrice);
    } else {
      setFinalPrice(calculationInfo);
    }
  }, [calculationInfo, inputDiscount, effectiveTaxation, inputSpecialDiscount])


  const handleChange = (e, roomTypeName, roomType) => {
    let totalPriceWood = 0;
    const { id, value, checked } = e.target;
    const { languages } = userinfo;
    let quoteChecked = [];

    setSelectedDesigns({
      ...selectedDesigns,
      [roomTypeName]: checked ? id : null
    });

    if (checked) {
      peopleInfo.push(id);
      setCalculationInfo(calculationInfo + 1);
    } else {
      for (var i = 0; i < peopleInfo.length; i++) {
        if (peopleInfo[i] === id) {
          peopleInfo.splice(i, 1);
          setCalculationInfo(calculationInfo - 1);
        }
      }
    }

    for (var i = 0; i < peopleInfo.length; i++) {
      for (var j = 0; j < viewDatas.length; j++) {
        if (peopleInfo[i] === viewDatas[j].id || peopleInfo[i] === viewDatas[j].ID) {
          quoteChecked.push(viewDatas[j].roomTypePrice);
          if (
            viewDatas[j].roomType !== "Accessories" ||
            viewDatas[j].roomType !== "Loose Furniture" ||
            viewDatas[j].roomType !== "Other Works" ||
            viewDatas[j].roomType !== "ExtraItems"
          ) {
            totalPriceWood += viewDatas[j].roomTypeWoodPrice;
          }
        }
      }
    }

    setCalculationWood(totalPriceWood);

    const reducerOfPrice = (accumulator, currentValue) => accumulator + currentValue;
    const totalPrice = quoteChecked.reduce(reducerOfPrice, 0);
    setCalculationInfo(totalPrice);

    // Reset special discount whenever base total changes
    setInputSpecialDiscount(0);
  };


  const quoteDate = new Date().toLocaleDateString();

  const handleFinalQuotation = (e) => {
    e.preventDefault();
    setLoading(true);

    let quotationData = [];
    let quotationWood = 0;

    for (var i = 0; i < peopleInfo.length; i++) {
      for (var j = 0; j < viewDatas.length; j++) {
        if (peopleInfo[i] === viewDatas[j].id || peopleInfo[i] === viewDatas[j].ID) {
          quotationData.push(viewDatas[j]);
          if (
            viewDatas[j].roomType === "Kitchen" ||
            viewDatas[j].roomType === "Bedroom" ||
            viewDatas[j].roomType === "Foyer" ||
            viewDatas[j].roomType === "Living Room"
          ) {
            quotationWood += viewDatas[j].roomTypeWoodPrice;
            setCalculationWood(quotationWood);
          }
        }
      }
    }

    const payload = {
      quotationData,
      clientDetails: data,
      userDetials: [userDetailsLo],
      quotationName: inputTitle,
      quotationpermission: {
        "height": true,
        "width": true,
        "area": true
      },
      quotationBase: inputBase,
      quotationDiscount: inputDiscount,
      // Special discount: only sent when the field is visible (Phase 3, non-KKT)
      quotationSpecialDiscount: showSpecialDiscount ? inputSpecialDiscount : 0,
      quotationTaxation: effectiveTaxation,
      quotationDate: quoteDate,
      quotationWood: calculationWood,
      quotationPrice: calculationInfo,
      timestamp: new Date(),
      userId: data.ID
    };

    fetch(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/project/${data.id}/quotations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(() => {
        setLoading(false);
        if (data.path === 'assigneRooms') {
          navigation("/assigned/view-rooms", { state: data });
        } else {
          navigation("/projects/view-rooms", { state: data });
        }
      })
      .catch((error) => console.error('Error:', error));
  }


  // ─── Discount change handler: enforce location+phase cap ─────────────────
  const handleDiscountChange = (e) => {
    let val = parseFloat(e.target.value) || 0;
    if (maxDiscount !== undefined && val > maxDiscount) {
      val = maxDiscount;
    }
    setInputDiscount(val);
  };
  // ─────────────────────────────────────────────────────────────────────────


  // ─── Special Discount handler: cap at fixed ₹3,00,100 ───────────────────
  const maxSpecialDiscount = 540815;

  const handleSpecialDiscountChange = (e) => {
    let val = parseFloat(e.target.value) || 0;
    if (val > maxSpecialDiscount) {
      val = maxSpecialDiscount;
    }
    setInputSpecialDiscount(val);
  };
  // ─────────────────────────────────────────────────────────────────────────


  return (
    <Container fluid>
      <Row className='m-0'>
        <Col sm={1}>
          <Tab.Container>
            <Row>
            </Row>
          </Tab.Container>
        </Col>
        <Col sm={11}>
          <Row className="p-4">
            <Row className="w-auto">
              <Breadcrumb>
                <Breadcrumb.Item style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  color: "#333",
                  textTransform: "uppercase",
                  letterSpacing: "-0.5px",
                  transition: "all 0.3s ease",
                  marginLeft: "10px",
                  textDecoration: "none",
                  backgroundColor: "#FDC771",
                  borderRadius: "0 20px 20px 0",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  height: 30,
                  width: 'auto',
                  paddingRight: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }} href="/projects">
                  {data.path === 'assigneRooms' ? 'Assigne Rooms' : 'Projects Rooms'}
                </Breadcrumb.Item>

                <Breadcrumb.Item style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  color: "#333",
                  textTransform: "uppercase",
                  letterSpacing: "-0.5px",
                  transition: "all 0.3s ease",
                  marginLeft: "10px",
                  textDecoration: "none",
                  backgroundColor: "#FDC771",
                  borderRadius: "0 20px 20px 0",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  height: 30,
                  width: 'auto',
                  display: "flex",
                  paddingRight: "10px",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }} onClick={() => navigation("/projects/view-rooms", { state: data })}>
                  {data?.pname}
                </Breadcrumb.Item>

                <Breadcrumb.Item style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  color: "#333",
                  textTransform: "uppercase",
                  letterSpacing: "-0.5px",
                  transition: "all 0.3s ease",
                  marginLeft: "10px",
                  textDecoration: "none",
                  backgroundColor: "#FDC771",
                  borderRadius: "0 20px 20px 0",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  height: 30,
                  width: 'auto',
                  paddingRight: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }} active>Add Quotation</Breadcrumb.Item>
              </Breadcrumb>
            </Row>

            <Form onSubmit={handleFinalQuotation}>
              {result.map((i, ind) => (
                <Row key={i.ID}>
                  <Row className="mt-2">
                    <Col className="md-12">
                      <h2 style={{ fontSize: 20, fontFamily: 'Arial', fontWeight: 150 }}>
                        {i.roomTypeName}
                      </h2>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="table-container">
                        <div className="tableScroll">
                          <table responsive hover>
                            <thead>
                              <tr className="table-warning">
                                <th></th>
                                <th>Design Option</th>
                                <th></th>
                                <th>Components</th>
                                <th>Addtional H/W</th>
                                <th>Total</th>
                              </tr>
                            </thead>
                            <tbody className="table-light">
                              {viewDatas.map((l, index) => l.roomTypeName == i.roomTypeName ? (
                                <tr key={l.ID}>
                                  <td>
                                    <input
                                      value={l.roomTypePrice}
                                      disabled={l.roomTypePrice === 0}
                                      style={{ width: '20px', height: '20px' }}
                                      type="checkbox"
                                      id={l.ID}
                                      name={l.ID}
                                      onChange={(e) => handleChange(e, l.roomTypeName, l.roomType)}
                                    />
                                  </td>
                                  <td>{l.roomTypeDesign}</td>
                                  <td></td>
                                  <td>{'\u20B9'} {l.roomTypePrice}</td>
                                  <td>-</td>
                                  <td>{'\u20B9'} {l.roomTypePrice}</td>
                                </tr>
                              ) : null)}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <hr />
                    </Col>
                  </Row>
                </Row>
              ))}

              <Row className="mt-5">

                {/* Total */}
                <Col className="md-4 p-3 justify-content-center" style={{ backgroundColor: '#a0efff' }}>
                  <h2 style={{ fontSize: 24, fontFamily: 'Arial', fontWeight: 100 }}>
                    Total : ₹ {finalPrice}
                  </h2>
                </Col>

                {/* Taxation — locked at 18% for Phase 2 & 3, free in Phase 1 */}
                <Col className="md-4 p-3 justify-content-center" style={{ backgroundColor: '#a0efff' }}>
                  <Form.Control
                    type="number"
                    placeholder="Taxation"
                    className="w-75"
                    name='QuotationTaxation'
                    value={isGSTFixed ? 18 : (InputTaxation || '')}
                    readOnly={isGSTFixed}
                    onChange={(e) => !isGSTFixed && setInputTaxation(e.target.value)}
                    style={isGSTFixed ? { backgroundColor: '#e9ecef', cursor: 'not-allowed' } : {}}
                  />
                  {isGSTFixed && (
                    <small style={{ color: '#6c757d', fontSize: '11px' }}>GST fixed at 18%</small>
                  )}
                </Col>

                {/* Discount
                    BLR Phase 1 : unlimited
                    BLR Phase 2 : max 25%
                    BLR Phase 3 : max 5%
                    KKT all     : unlimited
                */}
                <Col className="md-4 p-3 justify-content-center" style={{ backgroundColor: '#a0efff' }}>
                  <Form.Control
                    type="number"
                    placeholder="Discount"
                    className="w-75"
                    name='QuotationDiscount'
                    max={maxDiscount}
                    step="0.1"
                    onChange={handleDiscountChange}
                    onInvalid={(e) => {
                      if (maxDiscount !== undefined) {
                        e.target.setCustomValidity(`Maximum limit reached`);
                      }
                    }}
                    onInput={(e) => e.target.setCustomValidity('')}
                  />
                </Col>

                {/* Special Discount — visible only in Phase 3 for non-KKT locations */}
                {showSpecialDiscount && (
                  <Col className="md-4 p-3 justify-content-center" style={{ backgroundColor: '#a0efff' }}>
                    <Form.Control
                      type="number"
                      placeholder="Special Discount (₹)"
                      className="w-75"
                      name='QuotationSpecialDiscount'
                      min={0}
                      max={maxSpecialDiscount}
                      value={inputSpecialDiscount || ''}
                      onChange={handleSpecialDiscountChange}
                      onInvalid={(e) => e.target.setCustomValidity(`Max special discount is ₹${maxSpecialDiscount.toLocaleString('en-IN')}`)}
                      onInput={(e) => e.target.setCustomValidity('')}
                      disabled={calculationInfo === 0}
                      style={calculationInfo === 0 ? { backgroundColor: '#e9ecef', cursor: 'not-allowed' } : {}}
                    />
                  </Col>
                )}

                {/* Title */}
                <Col className="md-4 p-3 justify-content-center" style={{ backgroundColor: '#a0efff' }}>
                  <Form.Control
                    type="text"
                    placeholder="Title (Mandatory)*"
                    className="w-75"
                    name='QuotationTitle'
                    onChange={(e) => setInputTitle(e.target.value)}
                  />
                </Col>

                {/* Submit */}
                <Col className="md-4 p-3 justify-content-center" style={{ backgroundColor: '#a0efff' }}>
                  <Button
                    className="w-75 p-2 rounded-5"
                    style={{ fontSize: 20, fontWeight: 600 }}
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />{" "}
                        Creating...
                      </>
                    ) : (
                      "Create"
                    )}
                  </Button>
                </Col>

              </Row>
            </Form>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}